

























import Vue from 'vue';
import { User } from '~/services/IdentityService';

// Utils
import userDataToName from '~/utils/user/userDataToName';

interface UserData {
    data: User;
}

export default Vue.extend({
    name: 'Header',
    props: {
        label: {
            type: String,
            default: '',
            required: false,
        },
        overlap: {
            type: String as () => 'small' | 'large',
            default: 'small',
        },
        size: {
            type: String as () => 'small' | 'medium' | 'large',
            default: 'small',
        },
        maxWidth: {
            type: String as () => 'medium' | 'large',
            default: 'medium',
        },
        image: {
            type: String,
            default: '',
        },
        disableTitle: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        userData(): UserData {
            // @ts-ignore
            return this.$interfaces.user.me.get({ reactive: true });
        },
        fullName(): string {
            return userDataToName(this.userData.data || {}, 'tests.header');
        },
        backgroundURL(): string | null {
            if (!this.image) {
                return null;
            }
            return `url(${this.image}) !important;`;
        },
        styles() {
            const styles = {} as { 'background-image'?: string };
            if (this.backgroundURL) {
                styles['background-image'] = this.backgroundURL;
            }
            return Object.entries(styles)
                .map(([key, value]) => `${key}: ${value}`)
                .join(';');
        },
    },
});
